import { Menu } from '@mui/icons-material'
import { IconButton } from '@mui/material'

export const MobileMenuController = ({ onClick }) => {
  return  (
    <IconButton sx={{  flexShrink: 1 }} onClick={onClick}>
      <Menu/>
    </IconButton>
  )

}